import {FKOPages} from '@/common/fko-utils';
import {useGetSport} from '@/common/useGetSport';
import FAQSection, {FAQItem} from '@/components/FAQSection/FAQSection';
import {useAppSelector} from '@/redux/reduxUtils';
import {DBATFAQ} from './DBATFAQ';
import {FKOFAQ} from './FKOFAQ';

const faqMapping: Record<string, FAQItem[]> = {
  toca: FKOFAQ,
  dbat: DBATFAQ,
};

const getFaqsBySportType = (sport: string): FAQItem[] => {
  return faqMapping[sport] ?? [];
};

export const FKOFAQSection = () => {
  const {sport} = useGetSport();
  const {currentPage} = useAppSelector((state) => state.fkoFormDataReducer);

  if (currentPage !== FKOPages.CONTACT_INFO) {
    return null;
  }

  const faqs = getFaqsBySportType(sport);

  return (
    <div className="hidden lg:block">
      <FAQSection faqs={faqs} />
    </div>
  );
};
